import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Play, X } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export const DoctorVideo = () => {
  const [url, setUrl] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!API) return;
    axios.get(`${API}/api/media/doctor-video`).then(({ data }) => setUrl(data?.url ?? null)).catch(() => {});
  }, []);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    window.addEventListener("keydown", onKey);
    window.__lenis?.stop();
    return () => { window.removeEventListener("keydown", onKey); window.__lenis?.start(); };
  }, [open]);
  if (!url) return null;
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="doctor-video-btn"
        className="group absolute top-5 left-5 z-10 inline-flex items-center gap-3 rounded-full bg-[#FCFBF7]/90 backdrop-blur-md pl-2 pr-5 py-2 text-[#1B3B28] shadow-lg hover:bg-[#FCFBF7] transition-colors">
        <span className="relative grid place-items-center w-11 h-11 rounded-full bg-[#1B3B28] text-[#FCFBF7]">
          <span className="pulse-ring absolute inset-0 rounded-full bg-[#86C89B]" />
          <Play size={16} className="relative ml-0.5" fill="currentColor" />
        </span>
        <span className="text-sm font-medium">Un saluto dal Dottore</span>
      </button>
      {createPortal(
        <AnimatePresence>
          {open && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={() => setOpen(false)}
              className="fixed inset-0 z-[80] grid place-items-center bg-[#0F2317]/90 backdrop-blur-xl p-4 sm:p-10" role="dialog" aria-modal="true" aria-label="Video del Dott. Nicola Mauro" data-testid="doctor-video-modal">
              <button onClick={() => setOpen(false)} data-testid="doctor-video-close" aria-label="Chiudi"
                className="absolute top-5 right-5 grid place-items-center w-12 h-12 rounded-full bg-[#86C89B] text-[#0F2317]"><X size={18} /></button>
              <motion.video initial={{ scale: 0.94 }} animate={{ scale: 1 }} src={`${API}${url}`} controls autoPlay playsInline onClick={(e) => e.stopPropagation()}
                className="max-h-[85vh] max-w-full rounded-2xl bg-black shadow-2xl" data-testid="doctor-video-player" />
            </motion.div>
          )}
        </AnimatePresence>,
        document.body,
      )}
    </>
  );
};
